module.exports = __webpack_public_path__ + "bd19ad60600a1537c00d3b4923a5e5de.ttf";